import React from 'react'

import MediaAvatar from '../../../../atoms/MediaAvatar'
import Content from './Content'
import AvatarGroup from '../../../AvatarGroup'

import { useQueueState } from '../../../../../providers/QueueStateProvider'
import { useEnvironment } from '../../../../../providers/EnvironmentProvider'
import { useUserAPI } from '../../../../../providers/UserAPIProvider'
import { useAgent } from '../../../../../providers/AgentProvider'

import useStyles from './styles'

const OpenConversation = ({ conversation, modal, onClick = () => null }) => {
  const { id: selected, handleSelect } = useQueueState()
  const { users, name, session } = conversation

  const { user } = useEnvironment()
  const { allUsers } = useUserAPI()
  const { currentUser } = useAgent()

  const isViewing = session && sessionStorage.getItem('viewing') === session
  const isYours = users?.includes(currentUser()?.id) || isViewing
  const pickedUp = isYours

  const [hovering, setHovering] = React.useState(false)

  const isSelected = session === selected

  const convoUsers = React.useMemo(() => {
    const others = []

    users.forEach(id => {
      if (id !== user?.id) {
        const user = allUsers[id]
        if (user) {
          others.push(user)
        }
      }
    })

    return others
  }, [users, user, allUsers])

  const convoName = React.useMemo(() => {
    if (name && name !== 'Guest') {
      return name
    }

    if (convoUsers.length === 0) {
      return 'You'
    }

    const otherNames = convoUsers.map(u => u.name).join(', ')
    if (!isYours) {
      return otherNames
    }

    return `You & ${otherNames}`
  }, [name, convoUsers, isYours])

  const classes = useStyles({ selected: !modal && isSelected })

  return (
    <div className={classes.holder}>
      <div
        onClick={() =>
          modal
            ? onClick(conversation.session)
            : handleSelect(conversation.session)
        }
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        className={classes.root}
      >
        <div className={classes.avatarArea}>
          <AvatarGroup>
            {isYours && <MediaAvatar user={user} showBadge group />}

            {convoUsers.map(user => (
              <MediaAvatar key={user.id} user={user} showBadge group />
            ))}
          </AvatarGroup>
        </div>

        <Content
          name={convoName}
          conversation={conversation}
          hovering={hovering}
          modal={modal}
          pickedUp={pickedUp}
        />
      </div>
    </div>
  )
}

export default OpenConversation
